export const makeActiveColor = () => {
  try {
    if (typeof G.mp.maker.mainColor === "function")
      return G.mp.maker.mainColor(1);
    return G.collabo_type === "" ? "#FF6B00" : "#2979FF";
  } catch (e) {
    return "#2979FF";
  }
};
export const makeActiveColor2 = () => {
  try {
    return G.collabo_type === ""
      ? "rgba(255, 107, 0, 0.2)"
      : "rgba(178, 215, 255, 0.2)";
  } catch (e) {
    return "rgba(178, 215, 255, 0.2)";
  }
};
